<template>
  <div class="continer" v-if="!isError">
    <van-pull-refresh
      v-model="isLoading"
      success-text="刷新成功"
      @refresh="onRefresh"
    >
      <div class="header">
        <!-- 返回 -->
        <div class="back" @click="goBack()">
          <img
            src="@/assets/images/recharge_task/white_back.png"
            alt=""
            srcset=""
          />
        </div>
        <!-- 标题 -->
        <div class="title">
          <img src="@/assets/images/recharge_task/title.png" alt="" srcset="" />
        </div>
        <!-- 时间 -->
        <div class="time">
          <div class="time-desc">活动倒计时：</div>
          <div class="time-block">
            <div class="hours white-bg">{{ remainTime.hours }}</div>
            <!-- 分割符 -->
            <div class="colon">:</div>
            <div class="minutes white-bg">{{ remainTime.minutes }}</div>
            <div class="colon">:</div>
            <div class="seconds white-bg">{{ remainTime.seconds }}</div>
          </div>
        </div>
        <!-- 侧标签 -->
        <div class="side-tag">
          <div class="rules" @click="ruleShow = true">规则</div>
          <div class="record" @click="goRecord()">记录</div>
        </div>
      </div>
      <div class="main">
        <div class="list">
          <div
            class="list-item card"
            v-for="(item, index) in pageData"
            :key="index"
          >
            <div class="top">
              <div class="icon">
                <img :src="item.ad_icon" alt="" srcset="" />
              </div>
              <div class="desc">
                <div class="ad_name">{{ item.ad_name }}</div>
                <div class="task_info">
                  <div class="task_award">
                    奖<span class="money">{{ item.money }}</span
                    >元
                  </div>
                  <div class="task_name">(限时充值{{ item.volume }}元)</div>
                </div>
              </div>
            </div>
            <!-- 进度 -->
            <div class="progress">
              <div
                class="progress-bar"
                :style="{ '--progress-width': `${item.progress}%` }"
              ></div>
              <div class="progress-text">
                <div class="left">
                  当前：<span>{{ item.current_volume }}</span
                  >元
                </div>
                <div class="right">{{ item.volume }}元</div>
              </div>
            </div>
            <!-- 按钮 -->
            <div class="button">
              <div
                class="inner"
                :class="[
                  item.status == 1
                    ? 'may_receive'
                    : item.status == 2
                    ? 'already_receive'
                    : item.status == 3
                    ? 'already_receive'
                    : '',
                ]"
                @click="receiveAward(item)"
              >
                {{
                  item.status == 1
                    ? '立即领取'
                    : item.status == 2
                    ? '已领取'
                    : item.status == 3
                    ? '审核中'
                    : '去试玩'
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>

    <!-- 规则 -->
    <van-popup v-model="ruleShow" :close-on-click-overlay="false">
      <div class="introduce">
        <div class="title">
          <div class="inner">活动规则</div>
        </div>
        <div class="rule_info">
          <div v-html="introduce" />
        </div>
      </div>
      <div class="close" @click="ruleShow = false"></div>
    </van-popup>
  </div>
  <div v-else class="empty">
    <van-empty image="error" description="出现了一点问题~" />
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast, Empty, PullRefresh, Popup } from 'vant'

Vue.use(Toast)
  .use(Empty)
  .use(Popup)
  .use(PullRefresh)
export default {
  data() {
    return {
      // 剩余时间
      remainTime: {
        hours: '',
        minutes: '',
        seconds: '',
      },
      pageData: null,
      // 参数
      appId: '',
      userId: '',
      // 记录错误
      isError: false,
      // 下拉刷新
      isLoading: false,
      // 规则
      ruleShow: false,
      introduce:
        '1.试玩指定游戏，倒计时间内充值金额达到任务要求，回到活动页刷新后，即可领取活动奖励<br/>2.页面显示的当前充值金额为当日12:00～次日11:59的累计充值数据，实际充值时间以商家实际返回时间为准；<br/>3.活动奖励需在完成任务后，自行在活动页面领取（领奖截止时间同活动时间一致），奖励将在2个工作日内，以平台货币形式发放至您的平台账户；<br/>4. 活动最终解释权归本APP所有',
      // 计时器
      countdownInterval: null,
    }
  },
  created() {
    this.init()
  },
  // 销毁页面清除定时器
  beforeDestroy() {
    clearInterval(this.countdownInterval)
    console.log('销毁页面清除定时器')
  },
  computed: {
    // 当前日期
    currentDate() {
      const today = new Date()
      const year = today.getFullYear() // 获取年份
      const month = String(today.getMonth() + 1).padStart(2, '0') // 获取月份（注意：月份从0开始，所以加1，并用padStart确保两位数）
      const day = String(today.getDate()).padStart(2, '0') // 获取日期，并用padStart确保两位数
      return `${year}-${month}-${day}` // 格式化为 YYYY-MM-DD
    },
  },
  methods: {
    init() {
      // 初始化参数
      this.appId = this.getCookie('app_id')
      this.userId = this.getCookie('userid')
      if (!this.appId || !this.userId) {
        this.appId = this.$route.query.app_id
        this.userId = this.$route.query.user_id
      }
      // 获取数据不带状态
      this.getDailyTaskQuick()
      setTimeout(() => {
        // 获取数据带状态
        this.getDailyTaskStatus()
      }, 100)
      // 开始计时
      this.getRemainTime()
      this.startCountdown()
    },
    getCookie: function(name) {
      let strcookie = document.cookie //获取cookie字符串
      let arrcookie = strcookie.split('; ') //分割
      //遍历匹配
      for (const element of arrcookie) {
        let arr = element.split('=')
        if (arr[0] == name) {
          return arr[1]
        }
      }
      // appid 为空 返回 1000000001(乐乐赚)
      if (name == 'app_id') {
        return '1000000001'
      }
      return ''
    },
    callClienFunc: function(fname, fval) {
      if (window.hasOwnProperty('injectedObject')) {
        window.injectedObject.setJsContent(fname, fval)
      } else {
        fval = fval ? fval : {}
        let params = { method: fname, params: fval }
        params = JSON.stringify(params)
        window.Android.postMessage(params)
      }
    },
    goBack() {
      this.callClienFunc('closeWebview', '')
    },
    // 去试玩
    goPlay(ad_id) {
      window.location.href = `lezhuan://jump?type=39&content={"cpl_id":${ad_id}}`
    },
    getDailyTaskQuick() {
      const params = {
        app_id: this.appId,
        userid: this.userId,
      }

      console.log(params)
      return new Promise((resolve, reject) => {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
        })
        this.$http
          .get('https://adv.bugmake.com/api/cpl/get_recharge_task_quick', {
            params,
          })
          .then((res) => {
            console.log(res)
            if (res.code != 1) {
              this.isError = true
              return reject()
            }
            this.pageData = res.data.list
            this.isError = false
            resolve()
          })
          .catch((err) => {
            console.log(err)
            this.isError = true
            reject()
          })
          .finally(() => {
            Toast.clear()
          })
      })
    },
    // 点击按钮
    receiveAward(item) {
      if (item.status == 0) {
        this.goPlay(item.cpl_id)
        return
      }
      if (item.status == 2 || item.status == 3) {
        return
      }
      if (item.status != 1) {
        Toast({
          message: '未达到领取要求',
          position: 'bottom',
        })
        return
      }
      const params = {
        app_id: this.appId,
        userid: this.userId,
        ad_id: item.cpl_id,
        task_id: item.task_id,
      }
      let msg = '成功'
      this.$http
        .post(
          'https://adv.bugmake.com/api/cpl/complete_daily_recharge_task',
          params
        )
        .then((res) => {
          if (res.code != 1) {
            msg = res.message
            // code == 1003 刷新页面
            if (res.code == 1003) {
              this.init()
            }
            return
          }
          // 修改状态
          item.status = 2
        })
        .catch((err) => {
          console.log(err)
          msg = '领取失败'
        })
        .finally(() => {
          Toast({
            message: msg,
            position: 'bottom',
          })
        })
    },
    // 刷新
    async onRefresh() {
      await this.getDailyTaskStatus()
      this.isLoading = false
    },
    // 计算剩余时间
    getRemainTime() {
      const now = new Date()
      let start, end

      // 设置当前日期的12点时间
      const todayNoon = new Date(now)
      todayNoon.setHours(12, 0, 0, 0)

      if (now.getHours() < 12) {
        // 当前时间小于12点: 昨天12点到今天12点
        end = todayNoon
        start = new Date(todayNoon)
        start.setDate(start.getDate() - 1)
      } else {
        // 当前时间大于等于12点: 今天12点到明天12点
        start = todayNoon
        end = new Date(todayNoon)
        end.setDate(end.getDate() + 1)
      }

      const diff = end.getTime() - now.getTime()

      if (diff <= 0) {
        this.remainTime = {
          hours: '00',
          minutes: '00',
          seconds: '00',
        }
        return
      }

      const hours = Math.floor(diff / (1000 * 60 * 60))
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((diff % (1000 * 60)) / 1000)

      // 保存数据
      this.remainTime = {
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0'),
      }
      console.log(this.remainTime)
    },
    // 倒计时函数
    startCountdown() {
      // 如果未初始化，则初始化
      if (
        this.remainTime.hours == '' &&
        this.remainTime.minutes == '' &&
        this.remainTime.seconds == ''
      ) {
        console.log('初始化倒计时')
        this.getRemainTime()
      }
      // 先清除旧计时器
      clearInterval(this.countdownInterval)

      // 直接操作 remainTime 对象进行倒计时
      this.countdownInterval = setInterval(() => {
        // 将当前时间转换为秒数进行计算
        let totalSeconds =
          parseInt(this.remainTime.hours) * 3600 +
          parseInt(this.remainTime.minutes) * 60 +
          parseInt(this.remainTime.seconds)

        // 如果时间已到，保持为0且清除计时器
        if (totalSeconds <= 0) {
          this.remainTime = {
            hours: '00',
            minutes: '00',
            seconds: '00',
          }
          clearInterval(this.countdownInterval)
          // 重新加载页面
          this.init()
          return
        }

        // 扣减一秒
        totalSeconds--

        // 重新计算时分秒
        const hours = Math.floor(totalSeconds / 3600)
        const minutes = Math.floor((totalSeconds % 3600) / 60)
        const seconds = totalSeconds % 60

        // 更新 remainTime
        this.remainTime = {
          hours: String(hours).padStart(2, '0'),
          minutes: String(minutes).padStart(2, '0'),
          seconds: String(seconds).padStart(2, '0'),
        }
        // console.log(
        //   `${this.remainTime.hours}:${this.remainTime.minutes}:${
        //     this.remainTime.seconds
        //   }`
        // )
      }, 1000)
    },
    // 跳转记录
    goRecord() {
      this.$router.push({
        path: '/recharge_task/record',
        query: {
          app_id: this.appId,
          user_id: this.userId,
        },
      })
    },
    // 获取全部任务信息带状态
    getDailyTaskStatus() {
      const params = {
        app_id: this.appId,
        userid: this.userId,
      }

      console.log(params)
      return new Promise((resolve, reject) => {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
        })
        this.$http
          .get('https://adv.bugmake.com/api/cpl/get_daily_recharge_task', {
            params,
          })
          .then((res) => {
            console.log(res)
            if (res.code != 1) {
              this.isError = true
              return reject()
            }
            this.pageData = res.data.list
            this.isError = false
            resolve()
          })
          .catch((err) => {
            console.log(err)
            this.isError = true
            reject()
          })
          .finally(() => {
            Toast.clear()
          })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.continer {
  max-width: inherit;
  font-family: PingFangSC-Medium;
  // min-height: 100dvh;
  // background-image: linear-gradient(180deg, #ffd487 1%, #ffe8ca 6%);
}

.header {
  height: 1.7rem;
  padding-top: 0.3rem;
  background: url('~@/assets/images/recharge_task/header.png') no-repeat center;
  background-size: 100% 100%;

  .back {
    display: flex;
    align-items: center;
    height: 0.33rem;
    padding: 0 0.15rem;

    img {
      width: 0.14rem;
    }
  }

  .title {
    width: 3rem;
    margin: 0 auto;

    img {
      width: 100%;
    }
  }

  .time {
    width: 2.2rem;
    height: 0.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    background: url('~@/assets/images/recharge_task/time.png') no-repeat center;
    background-size: 100% 100%;

    .time-desc {
      font-size: 0.14rem;
      color: #ffffff;
      font-weight: 600;
    }

    .time-block {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.16rem;
      color: #ff4644;
      text-align: center;
      font-weight: 600;

      .white-bg {
        background: #ffffff;
        width: 0.24rem;
        height: 0.2rem;
        line-height: 0.2rem;
        border-radius: 0.04rem;
      }

      .colon {
        color: #ffffff;
        margin: 0 0.05rem;
      }
    }
  }

  .side-tag {
    .rules,
    .record {
      display: flex;
      align-items: center;
      width: 0.24rem;
      height: 0.48rem;
      position: absolute;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 0.06rem 0 0 0.06rem;
      font-size: 0.16rem;
      color: #ffffff;
      text-align: center;
      line-height: 0.18rem;
      font-weight: 400;
    }

    .rules {
      top: 0.64rem;
      right: 0;
    }

    .record {
      top: 1.4rem;
      right: 0;
    }
  }
}

.main {
  padding: 0 0.14rem;
  margin-top: -0.44rem;
  padding-bottom: 0.1rem;

  .list {
    .card {
      box-sizing: border-box;
      width: 3.48rem;
      // height: 1.5rem;
      background: #ffffff;
      border-radius: 0.12rem;
      padding: 0.12rem 0.14rem;
      margin: 0.1rem 0;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .top {
        display: flex;

        .icon {
          margin-right: 0.1rem;
          width: 0.48rem;
          border-radius: 0.1rem;
          overflow: hidden;
          display: flex;
          align-items: center;

          img {
            width: 100%;
          }
        }

        .desc {
          .ad_name {
            font-size: 0.16rem;
            color: #333333;
            font-weight: 600;
            margin-bottom: 0.02rem;
          }

          .task_info {
            display: flex;

            .task_award {
              // width: 0.7rem;
              height: 0.22rem;
              line-height: 0.2rem;
              background: url('~@/assets/images/recharge_task/raward.png')
                no-repeat center;
              background-size: 100% 100%;
              font-size: 0.14rem;
              color: #ffffff;
              text-align: center;
              margin-right: 0.02rem;
              padding: 0 0.05rem;

              .money {
                font-size: 0.16rem;
                color: #fff677;
                font-weight: 600;
              }
            }

            .task_name {
              font-size: 0.14rem;
              color: #999999;
              font-weight: 400;
              // 超出省略
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              max-width: 1.8rem;
            }
          }
        }
      }

      .progress {
        margin: 0.1rem 0;

        .progress-bar {
          --progress-width: 0%;
          width: 3.15rem;
          height: 0.08rem;
          background: #fafafa;
          border-radius: 1rem;
          position: relative;

          &::after {
            content: '';
            display: block;
            width: var(--progress-width);
            height: inherit;
            position: absolute;
            left: 0;
            top: 0;
            background: #ff4644;
            border-radius: inherit;
          }
        }

        .progress-text {
          display: flex;
          justify-content: space-between;
          font-size: 0.12rem;
          color: #999999;

          .left {
            span {
              color: #ff4644;
              font-weight: 600;
            }
          }
        }
      }

      .button {
        .inner {
          width: 1.4rem;
          height: 0.34rem;
          line-height: 0.34rem;
          border-radius: 1rem;
          background-image: linear-gradient(103deg, #ff4b1f 0%, #ff0040 100%);
          font-size: 0.16rem;
          color: #ffffff;
          text-align: center;
          font-weight: 600;
          margin: 0 auto;
        }

        // 可领取
        .may_receive {
          background: #4da6ff;
        }

        // 已领取
        .already_receive {
          background: #e6e6e6;
        }
      }
    }
  }
}

.empty {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .van-pull-refresh__track {
  min-height: 100vh;
  background-image: linear-gradient(180deg, #ffd487 1%, #ffe8ca 6%);
}

.introduce {
  display: block;
  width: 3.28rem;
  min-height: 3.66rem;
  overflow: hidden;
  background: #ffffff;
  border-radius: 0.12rem;

  .title {
    height: 0.56rem;
    background: url('~@/assets/images/recharge_task/rules.png') no-repeat center;
    background-size: 101% 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .inner {
      font-size: 0.24rem;
      color: #ffffff;
      text-shadow: 0 0.02rem 0.04rem rgba(182, 39, 48, 0.4);
      font-weight: 400;
    }
  }

  .rule_info {
    display: block;
    min-height: 3.5rem;
    margin-bottom: 0.08rem;
    overflow: hidden;
    // margin-top: 0.1rem;

    div:first-child {
      display: block;
      width: 2.69rem;
      margin: 0 auto;
      margin-top: 0.2rem;
      // margin-bottom: 0.24rem;
      font-size: 0.14rem;
      text-align: justify;
      overflow: hidden;
      font-size: 0.16rem;
      color: #333333;
      font-weight: 400;
    }
  }
}
/deep/.van-popup {
  background: transparent;

  .close {
    display: block;
    width: 0.32rem;
    height: 0.32rem;
    background: url('~@/assets/images/recharge_task/close.png') no-repeat;
    background-size: 0.32rem 0.32rem;
    margin: 0 auto;
    margin-top: 0.24rem;
    overflow: hidden;
  }
}
</style>
